export default __webpack_public_path__ + "static/media/close-modal.dd80f83d.svg";